import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import MarketingNav from './Components/marketing/Nav'
import MarketingFooter from './Components/marketing/Footer'
import Home from './Pages/Home'

import Nav from './Components/Nav'
import Footer from './Components/Footer'
import { isAuthenticated } from './auth'

import Dashboard from './Pages/Dashboard'
import Devices from './Pages/Devices'
import Login from './Pages/Login'
import Payments from './Pages/Payments'
import Users from './Pages/Users'

const Shell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

// Public marketing site (served at "/") — its own nav/footer, no auth.
const MarketingLayout = () => (
  <Shell>
    <MarketingNav />
    <main style={{ flex: 1 }}>
      <Outlet />
    </main>
    <MarketingFooter />
  </Shell>
)

// Guarded admin shell: Nav + Footer wrap every protected page; unauthenticated
// users are bounced to /login (preserving where they came from).
const ProtectedLayout = () => {
  const location = useLocation()
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return (
    <>
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public marketing */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
      </Route>

      {/* Admin dashboard */}
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/users" element={<Users />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
)

export default App
